import React from 'react';
import { HeartHandshake, Calendar, Stethoscope, Phone } from 'lucide-react';

export function PostAdoptionInfo() {
  return (
    <section className="py-16 bg-primary/5 dark:bg-primary/20 high-contrast:bg-black">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">
            Co dalej po adopcji?
          </h2>
          <p className="body-large">
            Adopcja to dopiero początek wspólnej drogi. Dowiedz się, co będzie potrzebne w pierwszych dniach i miesiącach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Pierwsze dni */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
                <HeartHandshake className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
              </div>
              <h3 className="card-title">
                Pierwsze dni razem
              </h3>
            </div>
            
            <div className="space-y-4">
              <p className="body-medium">
                Pierwsze dni w nowym domu to okres adaptacji dla zwierzaka. Oto kilka wskazówek:
              </p>
              <ul className="list-disc pl-5 space-y-2 body-medium">
                <li className="body-medium no-margin">Przygotuj spokojne miejsce, gdzie zwierzak będzie mógł się schować</li>
                <li className="body-medium no-margin">Nie zmuszaj do kontaktu - pozwól mu poznawać dom w swoim tempie</li>
                <li className="body-medium no-margin">Zachowaj stałą rutynę karmienia i spacerów</li>
                <li className="body-medium no-margin">Ogranicz wizyty gości w pierwszym tygodniu</li>
                <li className="body-medium no-margin">Bądź cierpliwy - niektóre zwierzaki potrzebują więcej czasu na adaptację</li>
              </ul>
            </div>
          </div>

          {/* Opieka weterynaryjna */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
                <Stethoscope className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
              </div>
              <h3 className="card-title">
                Opieka weterynaryjna
              </h3>
            </div>
            
            <div className="space-y-4">
              <p className="body-medium">
                Regularna opieka weterynaryjna jest kluczowa dla zdrowia Twojego pupila:
              </p>
              <ul className="list-disc pl-5 space-y-2 body-medium">
                <li className="body-medium no-margin">Pierwsza wizyta kontrolna - 2 tygodnie po adopcji</li>
                <li className="body-medium no-margin">Regularne odrobaczanie i szczepienia</li>
                <li className="body-medium no-margin">Sterylizacja/kastracja (jeśli zwierzę nie jest jeszcze po zabiegu)</li>
                <li className="body-medium no-margin">Coroczne badania kontrolne</li>
                <li className="body-medium no-margin">Profilaktyka przeciwko pchłom i kleszczom</li>
              </ul>
            </div>
          </div>

          {/* Wsparcie po adopcji */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
                <Phone className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
              </div>
              <h3 className="card-title">
                Wsparcie po adopcji
              </h3>
            </div>
            
            <div className="space-y-4">
              <p className="body-medium">
                Nie zostawiamy naszych adoptujących samych:
              </p>
              <ul className="list-disc pl-5 space-y-2 body-medium">
                <li className="body-medium no-margin">Telefoniczne wsparcie behawioralne</li>
                <li className="body-medium no-margin">Pomoc w znalezieniu sprawdzonego weterynarza</li>
                <li className="body-medium no-margin">Porady dotyczące żywienia i pielęgnacji</li>
                <li className="body-medium no-margin">Kontakt z doświadczonymi opiekunami</li>
                <li className="body-medium no-margin">Pomoc w sytuacjach kryzysowych</li>
              </ul>
            </div>
          </div>

          {/* Obowiązki opiekuna */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
                <Calendar className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
              </div>
              <h3 className="card-title">
                Obowiązki opiekuna
              </h3>
            </div>
            
            <div className="space-y-4">
              <p className="body-medium">
                Pamiętaj o swoich zobowiązaniach:
              </p>
              <ul className="list-disc pl-5 space-y-2 body-medium">
                <li className="body-medium no-margin">Regularne wizyty kontrolne w pierwszym roku</li>
                <li className="body-medium no-margin">Informowanie fundacji o ewentualnych problemach</li>
                <li className="body-medium no-margin">Przesyłanie zdjęć i informacji o postępach</li>
                <li className="body-medium no-margin">Natychmiastowy kontakt w razie zaginięcia</li>
                <li className="body-medium no-margin">Zapewnienie odpowiedniej opieki przez cały okres życia zwierzęcia</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}